import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { LoanRepaymentStatusType } from '@apply/constants';

export const getLoanRepaidStatusColumnHtml = (repaidStatusType: LoanRepaymentStatusType) => {
    if (repaidStatusType == null) {
        return;
    } else {
        switch (repaidStatusType) {
            case LoanRepaymentStatusType.None:
                return (
                    <b>
                        <i className='red-text'>
                            <FontAwesomeIcon icon={faTimes} />
                        </i>
                    </b>
                );
            case LoanRepaymentStatusType.Part:
                return <>Part</>;
            case LoanRepaymentStatusType.Full:
                return (
                    <b>
                        <i className='green-text'>
                            <FontAwesomeIcon icon={faCheck} />
                        </i>
                    </b>
                );
        }
    }
};
